import { render, staticRenderFns } from "./SendLimitedCountConfirmationDialog.vue?vue&type=template&id=03dd2dcb"
import script from "./SendLimitedCountConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./SendLimitedCountConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports